import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { RadiobuttonComponent } from '@shared/components/radio-button/radio-button.component';
import { ToggleSwitchComponent } from '@shared/components/toggle-switch/toggle-switch.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-form-controls',
	imports: [
		SharedModule,
		ReactiveFormsModule,
		CheckboxComponent,
		RadiobuttonComponent,
		ToggleSwitchComponent,
		UiCodeBlockComponent,
	],
	templateUrl: './ui-form-controls.component.html',
	styleUrl: './ui-form-controls.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiFormControlsComponent {
	// Checkboxes
	checkboxControl1 = new FormControl(false);
	checkboxControl2 = new FormControl(true);
	checkboxControl3 = new FormControl(false);
	checkboxControl4 = new FormControl(false); // Unchecked disabled

	// Radio buttons
	radioControl1 = new FormControl('option1');
	radioControl2 = new FormControl('disabled');
	radioControl3 = new FormControl('error');

	// Switches
	switchControl1 = new FormControl(false);
	switchControl2 = new FormControl(false);
	switchControl3 = new FormControl(true);

	radioOptions = [
		{ label: 'Option 1', value: 'option1' },
		{ label: 'Option 2', value: 'option2' },
		{ label: 'Option 3', value: 'option3' },
	];

	checkboxOptions = [
		{ label: 'Email notifications', control: this.checkboxControl1 },
		{ label: 'Push notifications', control: this.checkboxControl2 },
		{ label: 'SMS notifications', control: this.checkboxControl3 },
	];

	switchOptions = [
		{ label: 'Enable feature', control: this.switchControl1 },
		{ label: 'Auto save', control: this.switchControl2 },
		{ label: 'Dark mode', control: this.switchControl3 },
	];

	generateCheckboxCode(attrs: {
		ngModel?: string;
		label?: string;
		helperText?: string;
		disabled?: boolean;
		error?: boolean;
		size?: string;
	}): string {
		let code = '<app-checkbox';

		if (attrs.ngModel) code += `\n    [(ngModel)]="${attrs.ngModel}"`;
		if (attrs.label) code += `\n    label="${attrs.label}"`;
		if (attrs.helperText) code += `\n    helperText="${attrs.helperText}"`;
		if (attrs.disabled) code += `\n    [disabled]="true"`;
		if (attrs.error) code += `\n    [error]="true"`;
		if (attrs.size) code += `\n    size="${attrs.size}"`;

		code += '\n/>';
		return code;
	}

	generateRadioCode(attrs: {
		value?: string;
		selectedValue?: string;
		selectedValueChange?: string;
		inputId?: string;
		label?: string;
		helperText?: string;
		disabled?: boolean;
		error?: boolean;
	}): string {
		let code = '<app-radio-button';

		if (attrs.value) code += `\n    [value]="'${attrs.value}'"`;
		if (attrs.selectedValue) code += `\n    [selectedValue]="${attrs.selectedValue}"`;
		if (attrs.selectedValueChange) code += `\n    (selectedValueChange)="${attrs.selectedValueChange}"`;
		if (attrs.inputId) code += `\n    inputId="${attrs.inputId}"`;
		if (attrs.label) code += `\n    label="${attrs.label}"`;
		if (attrs.helperText) code += `\n    helperText="${attrs.helperText}"`;
		if (attrs.disabled) code += `\n    [disabled]="true"`;
		if (attrs.error) code += `\n    [error]="true"`;

		code += '\n/>';
		return code;
	}

	generateSwitchCode(attrs: { ngModel?: string; disabled?: boolean; error?: boolean }): string {
		let code = '<app-toggle-switch';

		if (attrs.ngModel) code += `\n    [(ngModel)]="${attrs.ngModel}"`;
		if (attrs.disabled) code += `\n    [disabled]="true"`;
		if (attrs.error) code += `\n    [error]="true"`;

		code += '\n/>';
		return code;
	}

	generateDisabledExamples(): string {
		return `// Add [disabled]="true" to any control
<app-checkbox [disabled]="true" />
<app-radio-button [disabled]="true" />
<app-toggle-switch [disabled]="true" />`;
	}
}
